import React, { useEffect } from 'react';

function ProjectDrawer({ isOpen, onClose, project }) {
    // Prevent background scrolling when drawer is open
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    if (!isOpen || !project) return null;

    return (
        <div className="fixed inset-0 z-[100] flex justify-end">
            {/* Backdrop */}
            <div
                className="absolute inset-0 bg-black/60 backdrop-blur-sm transition-opacity"
                onClick={onClose}
            ></div>

            {/* Drawer Panel */}
            <div className="relative z-[101] h-full w-full max-w-md bg-white dark:bg-[#1a2333] shadow-2xl overflow-y-auto animate-slide-in-right p-8 border-l border-slate-200 dark:border-slate-800">
                <button
                    onClick={onClose}
                    className="absolute top-6 right-6 p-2 rounded-full hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors text-slate-500"
                >
                    <span className="material-symbols-outlined">close</span>
                </button>

                <div className={`inline-block px-3 py-1 rounded-full text-xs font-bold uppercase mb-4 ${project.colorClass} bg-primary/10`}>
                    {project.date}
                </div>

                {project.image ? (
                    <div className="h-48 mb-6 rounded-xl overflow-hidden bg-slate-200 border border-slate-200 dark:border-slate-700">
                        <img
                            src={project.image}
                            alt={project.title}
                            className="w-full h-full object-contain p-4"
                        />
                    </div>
                ) : (
                    <div className={`h-32 mb-6 rounded-xl bg-gradient-to-br ${project.gradientClass} flex items-center justify-center`}>
                        <span className={`${project.colorClass} text-4xl font-black`}>{project.bannerText || project.title}</span>
                    </div>
                )}

                <h2 className="text-3xl font-black mb-6 text-slate-900 dark:text-white leading-tight">
                    {project.title}
                </h2>

                <div className="space-y-6">
                    <div>
                        <h3 className="text-sm font-bold uppercase text-slate-500 dark:text-slate-400 mb-3 tracking-wider">Project Overview</h3>
                        <p className="text-slate-600 dark:text-[#92a4c9] leading-relaxed">
                            {project.description}
                        </p>
                    </div>

                    {project.roleDescription && (
                        <div>
                            <h3 className="text-sm font-bold uppercase text-slate-500 dark:text-slate-400 mb-3 tracking-wider">My Role & Contributions</h3>
                            <p className="text-slate-600 dark:text-[#92a4c9] leading-relaxed">
                                {project.roleDescription}
                            </p>
                        </div>
                    )}

                    <div>
                        <h3 className="text-sm font-bold uppercase text-slate-500 dark:text-slate-400 mb-3 tracking-wider">Technologies &amp; Domain</h3>
                        <div className="flex flex-wrap gap-2">
                            {project.tags.map((tag, index) => (
                                <span key={index} className="px-3 py-1.5 bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300 text-xs font-bold rounded-lg border border-slate-200 dark:border-slate-700">
                                    {tag}
                                </span>
                            ))}
                        </div>
                    </div>

                    {project.websiteUrl && (
                        <div className="pt-6 flex justify-center">
                            <a
                                href={project.websiteUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={`flex items-center gap-2 px-6 py-3 rounded-xl font-bold text-white transition-all shadow-lg hover:shadow-xl hover:-translate-y-1 ${project.colorClass.replace('text-', 'bg-').replace('400', '500')}`}
                            >
                                Visit Project Website
                                <span className="material-symbols-outlined text-lg">public</span>
                            </a>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ProjectDrawer;
